import SpriteSymbol from "../../../node_modules/svg-sprite-loader/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-itemcate",
  "use": "icon-itemcate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-itemcate\"><defs><style type=\"text/css\"></style></defs><path d=\"M754.4 264.1m-200 0a200 200 0 1 0 400 0 200 200 0 1 0-400 0Z\" fill=\"#ffffff\" p-id=\"66502\" /><path d=\"M754.4 759.6m-200 0a200 200 0 1 0 400 0 200 200 0 1 0-400 0Z\" fill=\"#ffffff\" p-id=\"66503\" /><path d=\"M265.4 759.6m-200 0a200 200 0 1 0 400 0 200 200 0 1 0-400 0Z\" fill=\"#ffffff\" p-id=\"66504\" /><path d=\"M265.4 128.1c36.3 0 70.5 14.1 96.2 39.8 25.7 25.7 39.8 59.8 39.8 96.2s-14.1 70.5-39.8 96.2c-25.7 25.7-59.8 39.8-96.2 39.8S195 386 169.3 360.3c-25.7-25.7-39.8-59.8-39.8-96.2s14.1-70.5 39.8-96.2 59.8-39.8 96.1-39.8m0-64c-110.5 0-200 89.5-200 200s89.5 200 200 200 200-89.5 200-200-89.5-200-200-200z\" fill=\"#ffffff\" p-id=\"66505\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/itemcate.svg
// module id = F87A
// module chunks = 7